import fetchInterceptor , {FetchOptions} from "../../../utils/fetchInterceptor ";
import { newsEndpoints } from "../apiEndPoints";
import { header } from "../../../context/constant";

const GetNewsAPI = async (id?: string) => {
  const url = id ? newsEndpoints.single(id) : newsEndpoints.all();
  const options: FetchOptions = {
    method: "GET",
    headers: header,
  };
  return fetchInterceptor(url, options);
};

export default GetNewsAPI;